module.exports = __webpack_public_path__ + "static/img/home-1.a9b2d777.jpg";